export const TAB_VIEW_WIDTH = 330;
export const TAB_VIEW_HEIGHT = 680;
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';